import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Phone, FileText } from "lucide-react";
import { SITE } from "@/data/site";
import SmartLink from "@/components/SmartLink";

const HIDDEN_PREFIXES = ["/admin", "/visite/", "/proprietaire/"];

const WhatsAppIcon = () => (
  <svg viewBox="0 0 24 24" className="w-4 h-4 shrink-0" fill="#25D366" aria-hidden="true">
    <path d="M17.47 14.38c-.3-.15-1.75-.86-2.02-.96-.27-.1-.47-.15-.67.15-.2.3-.77.96-.94 1.16-.17.2-.35.22-.64.07-.3-.15-1.26-.46-2.39-1.48-.88-.79-1.48-1.76-1.65-2.06-.17-.3-.02-.46.13-.6.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.08-.15-.67-1.61-.92-2.2-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.48 0 1.46 1.07 2.88 1.21 3.07.15.2 2.1 3.2 5.08 4.49.71.31 1.26.49 1.69.63.71.23 1.36.2 1.87.12.57-.09 1.75-.72 2-1.41.25-.69.25-1.29.17-1.41-.07-.12-.27-.2-.57-.35zM12.05 21.5h-.01a9.45 9.45 0 01-4.82-1.32l-.35-.21-3.58.94.96-3.49-.23-.36a9.43 9.43 0 01-1.45-5.03c0-5.22 4.25-9.47 9.48-9.47a9.4 9.4 0 016.7 2.78 9.4 9.4 0 012.77 6.7c0 5.22-4.25 9.46-9.47 9.46zm8.06-17.53A11.33 11.33 0 0012.05.63C5.77.63.66 5.74.66 12.02c0 2.01.52 3.97 1.52 5.69L.57 23.6l6.04-1.58a11.36 11.36 0 005.43 1.38h.01c6.28 0 11.39-5.11 11.39-11.39 0-3.04-1.19-5.9-3.33-8.05z" />
  </svg>
);

export const MobileStickyBar = () => {
  const { pathname } = useLocation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const r = document.getElementById("contact")?.getBoundingClientRect();
      const inContact = r && r.top < window.innerHeight && r.bottom > 0;
      setVisible(!inContact);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [pathname]);

  if (HIDDEN_PREFIXES.some((p) => pathname.startsWith(p))) return null;

  return (
    <>
      <div className="h-20 md:hidden" aria-hidden="true" />
      <div
        data-testid="mobile-sticky-bar"
        className={`md:hidden fixed bottom-0 inset-x-0 z-30 glass border-t border-white/10 px-4 pt-3 transition-transform duration-300 ${visible ? "translate-y-0" : "translate-y-full"}`}
        style={{ paddingBottom: "max(12px, env(safe-area-inset-bottom))" }}
      >
        <div className="grid grid-cols-[1fr_1.15fr_1.35fr] gap-2">
          <a href={`tel:${SITE.phoneRaw}`} data-testid="sticky-call-btn" className="btn-secondary justify-center !px-2 !gap-1.5 !text-[13px]">
            <Phone className="w-4 h-4 text-[#E50914] shrink-0" /> Appeler
          </a>
          <a
            href={`https://wa.me/33${SITE.phoneRaw.slice(1)}`}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="sticky-whatsapp-btn"
            aria-label="Écrire sur WhatsApp"
            className="btn-secondary justify-center !px-2 !gap-1.5 !text-[13px]"
          >
            <WhatsAppIcon /> WhatsApp
          </a>
          <SmartLink href={pathname === "/" ? "#contact" : "/#contact"} data-testid="sticky-quote-btn" className="btn-primary justify-center !px-2 !gap-1.5 !text-[13px] whitespace-nowrap">
            <FileText className="w-4 h-4 shrink-0" /> Devis gratuit
          </SmartLink>
        </div>
      </div>
    </>
  );
};
